exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container{background-color:white;padding:1.5rem}button{font-weight:bold !important}h1{color:#848484;border-bottom:1px solid #f0f0f0;text-transform:uppercase;margin-bottom:1rem}\n", ""]);

// exports
